import { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import { TNotificationIconProps } from './index';
import { Container } from 'components/EventAction/style';
import { GlobalIcon } from 'components/GlobalIcon';
import { useSportsNotifications } from 'hooks/sportsbook/useSportsNotifications';
import { getUserNotifications } from 'store/selectors/sport-data';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';
import './index.less';

export const NotificationIconContent = ({
  game,
  size,
  iconContainerSize
}: TNotificationIconProps): ReactElement => {
  const user = useSelector(getUser);
  const isLoggedIn = useSelector(getIsLoggedIn);

  const [notificationLoading, setNotificationLoading] = useState(false);

  const userSportNotifications = useSelector(getUserNotifications);

  const shouldSubscribeForNotifications =
    !userSportNotifications[game.id]?.events[0]?.is_subscribed;

  const { handleNotificationClick } = useSportsNotifications({
    notificationLoading,
    setNotificationLoading,
    game,
    shouldSubscribeForNotifications,
    userSportNotifications,
    userPending: !!user.pending,
    isLoggedIn
  });

  return (
    <Container
      onClick={handleNotificationClick}
      iconContainerSize={iconContainerSize}
      className="notificationIcon"
    >
      <GlobalIcon
        lib="generic"
        name={
          shouldSubscribeForNotifications ? 'notificationOff' : 'notificationOn'
        }
        theme="default"
        size={size}
        className="selectedIcon"
      />
    </Container>
  );
};
